import { Product } from "entities/products/types";
import { Studio } from "entities/studios/types";
import { FC, PropsWithChildren } from "react";
import { useDrawerState } from "shared/hooks/useDrawerState";
import { createContext } from "shared/utils/context";
import { StudiosPageType } from "./types";

const [Provider, useStudiosPage] = createContext<StudiosPageType>({
  name: "StudiosPageContext",
  hookName: "useStudiosPage",
  providerName: "StudiosPageProvider",
});

const StudiosPageProvider: FC<PropsWithChildren> = ({ children }) => {
  const studioDetailsDrawer = useDrawerState<Studio>();
  const productDetailsDrawer = useDrawerState<Product>();

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = {
    studioDetailsDrawer,
    productDetailsDrawer,
  };

  return <Provider value={value}>{children}</Provider>;
};

export { StudiosPageProvider, useStudiosPage };
